module.exports = __webpack_public_path__ + "static/media/icon-time.976e6d1c.svg";